var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('paginated-browser',{ref:"browserPenumpang",attrs:{"search-date-range":false,"data-callback":_vm.getPenumpang},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var pagination = ref.pagination;
return [_c('table-penumpang',{attrs:{"items":data}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9bf29e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrowsePenumpang.vue
// module id = null
// module chunks = 